angular.module('harriApp')
    .controller('SocialReferralInvitationController', [
        '$scope', '$state', '$stateParams', '$filter',
        function ($scope, $state, $stateParams, $filter) {

            $scope.loading = true;

            var init = function () {
                SocialReferralAPI.getSocialReferralInvitation($stateParams.job_id, $stateParams.token)
                    .then(function (data) {
                        if(data.invite){
                            $scope.invitationDetails = data.invite;
                            $scope.brandName = $scope.invitationDetails.brand_name.replace(/_|\-/, ' ');
                            var linkHostname = window.location.protocol + '//' + window.location.hostname;
                            var position = $scope.invitationDetails.position_name.replace(/\s+/g, '-').toLowerCase();

                            $scope.sharedLink = linkHostname + '/' + $scope.invitationDetails.brand_slug + '/job/'
                                + $scope.invitationDetails.job_id + '-' + encodeURIComponent(position)
                                + '?job_referrer_id=' + $scope.invitationDetails.job_referrer_id
                                + '&utm_source=social_referral';

                            var emailSharedLink = $scope.sharedLink + '&social_media_channel=mail';

                            $scope.emailSubject =  $filter('translate')('Come and work with me at ') + $scope.brandName + '!';

                            $scope.emailBody = $filter('translate')('Hey!') + '\n \n'  + $filter('translate')('We’re looking for a ')
                                + $scope.invitationDetails.position_name + $filter('translate')(' where I work at ') + $scope.brandName + '. \n'
                                + $filter('translate')('I think you\'d be a great fit so click the link below to look at the details and apply using the same link if you’re looking') + '. \n \n'
                                + $filter('translate')('Good Luck and hope we can work together soon!') + '\n \n' + emailSharedLink + '\n \n';

                            $scope.sharedLinkNoSocialMedia = $scope.sharedLink + '&social_media_channel=link';

                            $scope.$digest();
                        }
                        $scope.loading = false;
                    }, function (error) {
                        console.error(error)
                    })
            };

            $scope.copyLink = function () {
                var textarea = document.createElement("textarea");
                textarea.value = $scope.sharedLinkNoSocialMedia;
                document.body.appendChild(textarea);
                textarea.focus();

                try {
                    textarea.select();
                } catch (e) {}

                try {
                    textarea.setSelectionRange(0, textarea.value.length);
                } catch (e) {}

                var successful = document.execCommand('copy');

                if (successful) {
                    HNotifications.show({
                        title: $filter("translate")("Link copied to clipboard."),
                        desc: '',
                        icon: "fa-check",
                        type: "success",
                        timeout: 3000
                    });
                }

                document.body.removeChild(textarea);
            };

            init();


        }]);
